import { Button } from '@kalos/ui';

/**
 * A ToolFundAdmin requesting for someone else picks whose tool fund pays. Nothing is picked until
 * they choose, and each button says where the cost is taken from.
 */
export const WhoPaysChoice = ({
  requesteeName,
  requesteePays,
  onChange,
  disabled,
}: {
  requesteeName: string;
  requesteePays: boolean | undefined;
  onChange: (requesteePays: boolean) => void;
  disabled?: boolean;
}) => {
  const options = [
    {
      pays: false,
      label: `Request for ${requesteeName}`,
      detail: 'This will be deducted from my tool fund',
    },
    {
      pays: true,
      label: `Charge ${requesteeName}'s tool fund`,
      detail: `This will be deducted from ${requesteeName}'s tool fund`,
    },
  ];
  return (
    <div role="group" aria-label="Who pays" className="grid gap-3 md:grid-cols-2">
      {options.map((option) => (
        <Button
          key={option.label}
          type="button"
          variant={requesteePays === option.pays ? 'default' : 'outline'}
          aria-pressed={requesteePays === option.pays}
          disabled={disabled}
          onClick={() => onChange(option.pays)}
          className="h-auto min-h-11 flex-col items-start whitespace-normal py-3 text-left"
        >
          <span className="font-semibold">{option.label}</span>
          <span className="text-sm font-normal">({option.detail})</span>
        </Button>
      ))}
    </div>
  );
};
